import { createApiSlice } from 'app/createApiSlice'
import moment from 'moment-timezone'
import {
  API_ATTENDANCE_SUMMARY,
  API_FARMERS_PLOTTING,
  API_FARMERS_PLOTTING_SELF,
} from 'utils/apiList'

export const productionUnitApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'production-unit/api',
  endpoints(builder) {
    return {
      fetchProductionUnit: builder.query({
        query({ page, size = 10, sortby, sortdir, s, userId }) {
          return {
            url: API_FARMERS_PLOTTING,
            params: {
              search: s,
              page,
              size,
              sortby,
              sortdir,
              userId,
            },
          }
        },
      }),
      fetchProductionUnitSelf: builder.query({
        query({ page, size = 10, sortby, sortdir, s, userId }) {
          return {
            url: API_FARMERS_PLOTTING_SELF,
            params: {
              s,
              page,
              size,
              sortby,
              sortdir,
              userId,
            },
          }
        },
      }),
    }
  },
})

export const { useFetchProductionUnitQuery, useFetchProductionUnitSelfQuery } =
  productionUnitApiSlice
